module.exports = __webpack_public_path__ + "img/sketch-black-middle.b1514c99.png";